function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray2(arr); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import _JSXStyle from "styled-jsx/style";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import noop from 'lodash.noop';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import withDragHandler from "../Reorderable/DragHandler";
import ReorderableContainer from "../Reorderable/ReorderableContainer";
import ReorderableElement from "../Reorderable/ReorderableElement";
import HasManyFieldsAdd from "./HasManyFieldsAdd";
import HasManyFieldsRow from "./HasManyFieldsRow";
var DragHandler = withDragHandler();
var SortableItem = ReorderableElement(function (_ref) {
  var key = _ref.key,
      sortIndex = _ref.sortIndex,
      value = _ref.value,
      renderHasManyFieldsRow = _ref.renderHasManyFieldsRow;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex js-reorderable-item",
    key: key
  }, /*#__PURE__*/React.createElement(DragHandler, null), /*#__PURE__*/React.createElement("div", {
    className: "w-100"
  }, renderHasManyFieldsRow(null, sortIndex, value)));
});
var SortableContainer = ReorderableContainer(function (_ref2) {
  var value = _ref2.value,
      renderAddRow = _ref2.renderAddRow,
      renderHasManyFieldsRow = _ref2.renderHasManyFieldsRow;
  return /*#__PURE__*/React.createElement("div", null, value.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SortableItem, {
      key: "".concat(item.key ? item.key : index),
      index: index,
      sortIndex: index,
      value: item,
      renderHasManyFieldsRow: renderHasManyFieldsRow
    });
  }), renderAddRow());
});

var HasManyFields = /*#__PURE__*/function (_React$Component) {
  _inherits(HasManyFields, _React$Component);

  var _super = _createSuper(HasManyFields);

  function HasManyFields(props) {
    var _this;

    _classCallCheck(this, HasManyFields);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "updateItem", function (i) {
      return function (update) {
        _this.props.onUpdate(i, update);

        _this.value = [].concat(_toConsumableArray(_this.value.slice(0, i)), [update], _toConsumableArray(_this.value.slice(i + 1)));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "addItem", function () {
      _this.props.onAdd();

      var blank = typeof _this.props.blank === 'function' ? _this.props.blank(_this.value) : _this.props.blank;
      _this.value = _this.value.concat(blank);
      setTimeout(function () {
        return _this.focusRow(_this.rowRefs.length - 1);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteItem", function (i) {
      return function () {
        _this.props.onRemove(i);

        _this.value = [].concat(_toConsumableArray(_this.value.slice(0, i)), _toConsumableArray(_this.value.slice(i + 1)));
        setTimeout(function () {
          return _this.focusRow(_this.value.length > i ? i : i - 1);
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setRowReference", function (index) {
      return function (rowTemplate) {
        _this.rowRefs[index] = rowTemplate;

        if (_this.rowRefs.every(function (row) {
          return row === null;
        })) {
          _this.rowRefs = [];
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "focusRow", function (index) {
      var row = _this.rowRefs[index];

      if (!row) {
        return;
      }
      /* eslint-disable-next-line -- perhaos handle this when converting to FC/TS */


      var el = ReactDOM.findDOMNode(row);
      var firstInput = el.querySelectorAll('input, select, textarea')[0];
      firstInput && firstInput.focus(); // eslint-disable-line no-unused-expressions
    });

    _defineProperty(_assertThisInitialized(_this), "onSortEnd", function (_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;
      var result = Array.from(_this.value);

      var _result$splice = result.splice(oldIndex, 1),
          _result$splice2 = _slicedToArray(_result$splice, 1),
          removed = _result$splice2[0];

      result.splice(newIndex, 0, removed);
      _this.value = result;
    });

    _defineProperty(_assertThisInitialized(_this), "renderAddRow", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          label = _this$props.label,
          maximumRows = _this$props.maximumRows;

      if (_this.value.length < maximumRows) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HasManyFieldsAdd, {
          onClick: _this.addItem,
          disabled: disabled
        }, label));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "isStateless", function (Template) {
      var isFunction = typeof Template === 'function';
      return isFunction && !(Template.prototype && Template.prototype.render);
    });

    _defineProperty(_assertThisInitialized(_this), "renderHasManyFieldsRow", function (key, index, value) {
      var _this$props2 = _this.props,
          Template = _this$props2.template,
          disabled = _this$props2.disabled,
          deleteProps = _this$props2.deleteProps,
          errors = _this$props2.errors,
          minimumRows = _this$props2.minimumRows;
      var refProps = _this.isStateless(Template) ? {} : {
        ref: _this.setRowReference(index)
      };
      return /*#__PURE__*/React.createElement(HasManyFieldsRow, {
        onDelete: _this.deleteItem(index),
        key: key,
        deletable: _this.value.length > minimumRows,
        disabled: disabled,
        deleteProps: deleteProps
      }, /*#__PURE__*/React.createElement(Template, _extends({
        value: value,
        errors: errors[index],
        onChange: _this.updateItem(index),
        disabled: disabled,
        index: index
      }, refProps)));
    });

    _this.isUncontrolled = typeof props.value === 'undefined';

    if (_this.isUncontrolled) {
      _this.state = {
        value: props.defaultValue
      };
    }

    _this.rowRefs = [];
    return _this;
  }

  _createClass(HasManyFields, [{
    key: "value",
    get: function get() {
      return this.isUncontrolled ? this.state.value : this.props.value;
    },
    set: function set(value) {
      this.props.onChange(value);
      this.isUncontrolled && this.setState({
        value: value
      }); // eslint-disable-line no-unused-expressions
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          reorderable = _this$props3.reorderable;

      if (!disabled && reorderable) {
        return /*#__PURE__*/React.createElement("div", {
          className: "jsx-2612940199" + " " + (className || "")
        }, /*#__PURE__*/React.createElement(SortableContainer, {
          className: "js-reorderable-container",
          helperClass: "hmf-dragging",
          onSortEnd: this.onSortEnd,
          useDragHandle: true,
          lockAxis: "y",
          value: this.value,
          renderHasManyFieldsRow: this.renderHasManyFieldsRow,
          renderAddRow: this.renderAddRow
        }), /*#__PURE__*/React.createElement(_JSXStyle, {
          id: "2612940199"
        }, "div.jsx-2612940199{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}"));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, this.value.map(function (item, index) {
        return _this2.renderHasManyFieldsRow(index, index, item);
      }), this.renderAddRow());
    }
  }]);

  return HasManyFields;
}(React.Component);

_defineProperty(HasManyFields, "propTypes", {
  blank: PropTypes.any,
  defaultValue: PropTypes.array,
  disabled: PropTypes.bool,
  deleteProps: PropTypes.object,
  errors: PropTypes.array,
  label: PropTypes.string.isRequired,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onUpdate: PropTypes.func,
  onChange: PropTypes.func,
  template: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
  value: PropTypes.array,
  minimumRows: PropTypes.number,
  maximumRows: PropTypes.number,
  reorderable: PropTypes.bool
});

_defineProperty(HasManyFields, "defaultProps", {
  defaultValue: [],
  errors: [],
  onAdd: noop,
  onRemove: noop,
  onUpdate: noop,
  onChange: noop,
  minimumRows: 1,
  maximumRows: Infinity,
  reorderable: false
});

HasManyFields.displayName = "HasManyFields";
export default HasManyFields;